import Footer from "./parts/footer"
import HeaderInternal from "./parts/header-internal"

function Сongratulation() {
    return (
        <>
            <HeaderInternal />
            <div className="container w-full max-w-screen-sm m-auto my-16">
                <h1 className="text-3xl mb-6">Дякуємо за реєстрацію!</h1>
                <p className="mb-3">Залишились питання?</p>
                <p className="text-[16px] mb-[10px]">Яна</p>
                <a href="tel:+380672230179" className="block font-light text-[16px] mb-[10px] phone_click">+38 (067) 223
                    01 79</a>
                <a href="mailto:tickets@ekonomika.ua"
                   className="block font-light text-[16px] mb-[10px] email_sell_clk">tickets@ekonomika.ua</a>

            </div>
            <Footer/>
        </>

    )
}

export default Сongratulation;